import { z } from 'zod';
export const registrationChannelSchema = z.enum(['OnMyOwn', 'AssistedByPhone', 'SalesMeeting']);
export const registrationChannelStepSchema = z.object({
    channel: registrationChannelSchema.optional(),
});
